import React from 'react';
import PropTypes from 'prop-types';
import { Prompt } from 'react-router-dom';
import classNames from "classnames";
import Human from '../Icons/Human';
import CancelCircle from '../Icons/CancelCircle';
import { withStyles } from 'material-ui/styles';
import Button from "material-ui/Button";
import Chip from 'material-ui/Chip';
import { FormControl } from 'material-ui/Form';
import MenuItem from 'material-ui/Menu/MenuItem';
import Select from 'material-ui/Select';
import Typography from 'material-ui/Typography'
import NotificationBar from '../Parts/NotificationBar.jsx'
import Wrapper from '../common/Wrapper';
import Loader from '../Parts/Loader';
import ConfirmCloseDialog from './Basic/ConfirmCloseDialog';
import ArrowDropdown from '../Icons/ArrowDropdown';
import { isEnabledExportExecutiveList, isEnabledSendLetter, hasEverBeenEnabledExportPlan } from '../../utils/planUtils';
const { Set } = require('immutable');

const styles = () => ({
  container: {
    width: "100%",
    boxShadow: "0px 0px 6px #00000029",
    borderRadius: "4px",
    marginTop: "50px"
  },

  title: {
    display: "flex",
    justifyContent: "space-between",
    boxShadow: "0px 1px 0px #00000029",
    textAlign: "left",
    padding: '18px 25px',
    margin: 'auto 0',
  },

  content: {
    padding: "20px 25px 15px",
  },

  menuContent: {
    display: 'flex',
    marginBottom: '15px',
  },

  collapsed: {
    maxHeight: '300px',
    overflowY: 'hidden',
  },

  label: {
    paddingLeft: '0px',
  },

  icon: {
    minWidth: '41px',
    width: '41px',
    height: '41px',
    marginRight: '12px',
    background: '#040E35',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  },

  sectionHeader: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    borderBottom: '1px solid #D8DBDF',
    paddingBottom: '5px',
    marginBottom: '20px',
    position: 'relative',

    '&:before': {
      content: '""',
      display: 'block',
      width: '50px',
      borderBottom: '1px solid #195AFF',
      position: 'absolute',
      bottom: '-1px',
      left: 0,
    },
  },

  readSection: {
    width: '100%'
  },

  editSection: {
    width: '100%'
  },

  subSection: {
    marginBottom: 10,
  },

  searchSection: {
    marginBottom: '30px',
  },

  userContent: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  item: {
    padding: '10px 0',
    display: 'flex',
    width: '20%',
    margin: 'auto 0',
  },

  notExist: {
    padding: '5px 0',
    display: 'flex',
    margin: 'auto 0',
    fontSize: '13px',
  },

  userInfo: {
    margin: 'auto 0',
    fontSize: '15px',
  },

  deleteIcon: {
    alignItems: 'center',
  },

  button: {
    color: '#1A65FF',
    fontSize: '13px',
    minHeight: 'unset',
    padding: '6px 8px',
    minWidth: 54,
  },

  editButton: {
    float: "right",
    border: "1px solid #D8DBDF",
    fontSize: "15px",
    color: "#181819",
    padding: "10px 15px",
  },

  saveButton: {
    color: '#fff',
    float: "right",
    border: "1px solid #D8DBDF",
    fontSize: "15px",
    padding: "10px 15px",
    background: '#1A65FF',
  },

  menuButton: {
    fontSize: '13px',
    minHeight: 'unset',
    minWidth: 'unset',
  },

  expandBtnContainer: {
    marginTop: '20px',
    textAlign: 'center',
  },

  emptyContainer: {
    padding: '50px',
    background: '#FFFFFF',
    boxSizing: 'border-box',
    width: '100%',
  },

  LoaderContainer: {
    position: 'relative',
    height: '100px',
  },

  arrow: {
    transform: 'translateX(-100%)',
    position: 'absolute',
    right: '-35px',
    width: 'unset',
    height: 'unset',
    transition: 'transform 1s cubic-bezier(0.77, 0, 0.175, 1), -webkit-transform 0.3s cubic-bezier(0.77, 0, 0.175, 1)',
  },

  select: {
    paddingRight: 38,
    backgroundColor: '#F2F6F9',
    color: '#7C8297',
    fontSize: 15,
    padding: 15,
    border: 'none',
  },
});

class ChildAccountAuthoritySetting extends React.Component {
  initialState = {
    showNotification: false,
    timelineAuthority: 'read', //表示切り替え（閲覧 | 編集）
    exeAuthority: 'read',
    houseListAuthority: 'read',
    updateAuthority: '', //更新中の権限
    message: '',
    messageType: 'success',
    pageTransitionPathname: null, //ページ遷移するパス
    exeInfoOpen: false, //編集設定の詳細表示
    houseListInfoOpen: false,
    showConfirmCloseDialog: false,
    showConfirmPageTransitionDialog: false,
    delAccounts: { //権限を削除するアカウント
      letter_order: {
        read: Set(),
      },
      download_history: {
        read: Set(),
      },
      timeline: {
        read: Set(),
        edit: Set(),
      },
      executive_list: {
        read: Set(),
        order_letter: Set(),
        edit_tag: Set(),
        download_letter_ordered_list: Set(),
        download_list: Set()
      },
      house_list: {
        read: Set(),
        edit: Set(),
        order_letter: Set(),
        edit_tag: Set(),
        download_list: Set()
      },
    },
    addAccounts: { //権限を追加するアカウント
      letter_order: {
        read: Set(),
      },
      download_history: {
        read: Set(),
      },
      timeline: {
        read: Set(),
        edit: Set(),
      },
      executive_list: {
        read: Set(),
        order_letter: Set(),
        edit_tag: Set(),
        download_letter_ordered_list: Set(),
        download_list: Set(),
      },
      house_list: {
        read: Set(),
        edit: Set(),
        order_letter: Set(),
        edit_tag: Set(),
        download_list: Set()
      },
    }
  }

  constructor(props) {
    super(props);
    this.state = { ...this.initialState };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isSaving && !nextProps.isSaving) {
      this.handleReset()
      this.setState({
        updateAuthority: '',
      })
    }
    if (nextProps.message && nextProps.message !== '') {
      this.displayNotification(nextProps.message, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== '') {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== '') {
      this.displayNotification(nextProps.shortMessage, "green");
    }
  }

  toggleNotification = () => {
    this.setState({ showNotification: !this.state.showNotification });
  };

  toggleConfirmCloseDialog = () => {
    this.setState({
      showConfirmCloseDialog: !this.state.showConfirmCloseDialog,
    });
  }

  /**
   * ページ遷移確認ダイアログの表示状態を切り替える
   *
   * @param {string|null} pathname - 遷移先のパス名
   */
  toggleConfirmPageTransitionDialog = (pathname = null) => {
    const newState = {
      showConfirmPageTransitionDialog: !this.state.showConfirmPageTransitionDialog,
    };

    if (pathname) {
      // ページ遷移確認ダイアログで「離れる」がクリックされた場合に、後続の遷移を実行するためパスを保持しておく
      newState.pageTransitionPathname = pathname;
    }

    this.setState(newState);
  }

  displayNotification = (message, type = "success") => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    })
  };

  renderConfirmCloseDialog = () => {
    if (this.state.showConfirmCloseDialog) {
      return (
        <ConfirmCloseDialog
          isOpen={this.state.showConfirmCloseDialog}
          toggleDialog={this.toggleConfirmCloseDialog}
          action={this.handleReset}
          isPageTransition={false}
        />
      );
    }
  }

  /**
   * ページ遷移確認ダイアログを描画
   *
   * @returns {JSX.Element|null} ダイアログコンポーネントまたは null（ダイアログが表示されない場合）
   */
  renderConfirmPageTransitionDialog = () => {
    if (this.state.showConfirmPageTransitionDialog) {
      return (
        <ConfirmCloseDialog
          isOpen={this.state.showConfirmPageTransitionDialog}
          toggleDialog={this.toggleConfirmPageTransitionDialog}
          action={this.pageTransition}
          isPageTransition={true}
        />
      );
    }
  }

  renderNotification = () => {
    return (
      <div style={{ position: 'fixed', zIndex: 1000, top: 10, width: '99%' }}>
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={this.toggleNotification}
          autoClose={true}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : '100%',
          }}
        >
        </NotificationBar>
      </div>
    );
  };

  handleReset = () => {
    let resetState = { ...this.state.delAccounts };
    Object.keys(resetState).forEach(function (authorityKey) {
      Object.keys(resetState[authorityKey]).forEach(function (property) {
        resetState[authorityKey][property] = Set();
      });
    });
    this.setState({
      delAccounts: resetState,
      addAccounts: resetState,
      updateAuthority: '',
    })
  }

  /**
   * ページ遷移を制御しないよう遷移前に updateAuthority をリセットしてページ遷移を行う
   */
  pageTransition = () => {
    this.setState({
      updateAuthority: '',
    }, () => {
      this.props.goTo(this.state.pageTransitionPathname);
    });
  }

  handleSave = (property) => {
    const key = property.replaceAll('-', '_');
    let filter = {};
    filter['authority'] = property
    filter['del_account'] = this.state.delAccounts[key]
    filter['add_account'] = this.state.addAccounts[key]
    this.props.putChildUsersAuthority(filter)
  };

  handleClick = (property, value) => {
    // 変更が保存されなかった場合はポップアップを表示
    if (property === 'updateAuthority' && this.state.updateAuthority && this.state.updateAuthority !== value) {
      this.toggleConfirmCloseDialog()
    } else {
      this.setState({ [property]: value });
    }
  }

  // 権限の追加処理
  handleItemSelected = (property, type, ids) => {
    let selectIds = ids.filter(id => id !== -1)
    const key = property.replaceAll('-', '_');
    const authorityType = type.replaceAll('-', '_');
    let delAccounts = { ...this.state.delAccounts };
    let addAccounts = { ...this.state.addAccounts };
    let delSet = delAccounts[key][authorityType];
    // 「すべての権限」から権限が追加された場合は全ての権限を追加
    if (authorityType === 'all') {
      let delItem = this.state.delAccounts[key]
      let addItem = this.state.addAccounts[key]
      Object.keys(delAccounts[key]).forEach(function (authorityKey) {
        authorityKey = authorityKey.replaceAll('-', '_');
        addItem[authorityKey] = addAccounts[key][authorityKey].concat(selectIds);
        addItem.read = addAccounts[key].read.concat(selectIds);
        if (delAccounts[key][authorityKey]) {
          delItem[authorityKey] = delAccounts[key][authorityKey].filter(function (v) {
            return !selectIds.includes(v);
          })
          delItem.read = delAccounts[key].read.filter(function (v) {
            return !selectIds.includes(v);
          })
        }
      });
      this.setState({
        addAccounts: {
          ...this.state.addAccounts,
          [key]: {
            ...this.state.addAccounts[key], ...addItem
          }
        },
        delAccounts: {
          ...this.state.delAccounts,
          [key]: {
            ...this.state.delAccounts[key], ...delItem
          }
        },
      })
    } else {
      this.setState({
        addAccounts: {
          ...this.state.addAccounts,
          [key]: {
            ...this.state.addAccounts[key],
            [authorityType]: Set(selectIds),
            read: Set(selectIds),
          }
        },
      })
      if (delSet) {
        this.setState({
          delAccounts: {
            ...this.state.delAccounts,
            [key]: {
              ...this.state.delAccounts[key],
              read: delSet.filter(function (v) {
                return !selectIds.includes(v);
              }),
              [authorityType]: delSet.filter(function (v) {
                return !selectIds.includes(v);
              }),
            }
          }
        })
      }
    }
  }

  // 権限の削除処理
  handleDelete = (property, type, id) => {
    if (id !== -1) {
      const key = property.replaceAll('-', '_');
      const authorityType = type.replaceAll('-', '_');
      let delAccounts = { ...this.state.delAccounts };
      let addAccounts = { ...this.state.addAccounts };
      let delSet = delAccounts[key][authorityType];
      let addSet = addAccounts[key][authorityType];
      // 閲覧権限、全ての権限が削除された場合
      if (authorityType === 'read' || authorityType === 'all') {
        let delItem = this.state.delAccounts[key]
        let addItem = this.state.addAccounts[key]
        // 閲覧権限が削除された場合は全ての権限を削除する
        Object.keys(delAccounts[key]).forEach(function (authorityKey) {
          //「すべての権限」から権限が削除された場合は閲覧以外の権限を削除
          if (authorityType === 'all' && authorityKey === 'read') {
            return;
          }
          delItem[authorityKey] = delAccounts[key][authorityKey.replaceAll('-', '_')].add(id);
          addItem[authorityKey] = addAccounts[key][authorityKey.replaceAll('-', '_')].delete(id);
        });
        this.setState({
          delAccounts: {
            ...this.state.delAccounts,
            [key]: {
              ...this.state.delAccounts[key], ...delItem
            }
          },
          addAccounts: {
            ...this.state.addAccounts,
            [key]: {
              ...this.state.addAccounts[key], ...addItem
            }
          }
        })
      } else {
        this.setState({
          delAccounts: {
            ...this.state.delAccounts,
            [key]: {
              ...this.state.delAccounts[key],
              [authorityType]: delSet.add(id),
            }
          },
          addAccounts: {
            ...this.state.addAccounts,
            [key]: {
              ...this.state.addAccounts[key],
              [authorityType]: addSet.delete(id),
            }
          }
        })
      }
    }
  }

  // 編集権限の詳細表示を切り替え
  handleExpand = (property) => {
    this.setState({
      [property]: !this.state[property]
    })
  }

  // 権限一覧に表示する子アカウント
  haveAuthorityChildAccount = (property, type) => {
    const { childUsers } = this.props;
    const key = property.replaceAll('-', '_');
    const authorityType = type.replaceAll('-', '_');
    let delAccounts = this.state.delAccounts[key][authorityType] ? this.state.delAccounts[key][authorityType].toArray() : [];
    let addAccounts = this.state.addAccounts[key][authorityType] ? this.state.addAccounts[key][authorityType].toArray() : [];
    let childAccounts;
    // 権限がある、権限を追加した子アカウントを一覧に表示する
    // 権限の保存データがない子アカウント（ダウンロード履歴の権限が未設定など）は権限なしとして扱う
    childAccounts = childUsers && childUsers.filter(item => (item.user_role[property] && item.user_role[property][type] === true) || addAccounts.includes(item.id))
    // 権限がない、権限を削除した子アカウントを一覧から排除する
    childAccounts = childAccounts.filter(function (user) {
      return !delAccounts.includes(user.id);
    })
    return childAccounts;
  }

  renderExpandBtn = (type) => {
    const { classes } = this.props;
    let property = 'houseListInfoOpen';
    if (type === 'executive-list') {
      property = 'exeInfoOpen';
    }
    return (
      <div className={classes.expandBtnContainer}>
        <Button color="default" className={classes.button} onClick={() => this.handleExpand(property)}>
          詳細に設定する
          <div className={classes.arrow}
            style={{
              transform: !this.state[property] ? 'translateX(-100%) rotate(0deg)' : 'translateX(-100%) rotate(180deg)',
              top: !this.state[property] ? '5px' : 0,
            }}>
            <ArrowDropdown width={20} height={20} color={'#1A65FF'} /></div>
        </Button>
      </div>
    )
  }

  renderSection = (info, i, property) => {
    const { classes } = this.props;
    const account = this.haveAuthorityChildAccount(property, info.key);
    return (
      <div key={i}>
        <div className={classes.subSection}>
          <div className={classes.sectionHeader}>
            <Typography
              variant="body2"
              style={{ fontWeight: 'bold' }}
            >
              {info.title}
            </Typography>

          </div>
          <div className={classes.userContent}>
            {account && (
              account.map((item, i) => this.renderRow(item, i, info.key, property))
            )}
          </div>
          {account.length === 0 && (
            <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
          )}
        </div>
        <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none' }}>
          {this.renderSearchSection(property, info.key)}
        </div>
      </div>
    );
  }

  renderRow = (item, i, type, property) => {
    const { classes } = this.props;
    return (
      <div className={classes.item} key={i}>
        <div className={classes.icon} style={{ background: '#F2F6F9' }}>
          <Human width={25} height={25} color="#7C8297" />
        </div>
        <div className={classes.userInfo}>{item.name}</div>
        <div className={classes.deleteIcon} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none' }}>
          {(() => {
            if (type === 'read' && property === 'timeline') { //タイムラインの閲覧は一旦編集不可
            } else {
              return (
                <div className={classes.delete}>
                  <Chip
                    onDelete={() => this.handleDelete(property, type, item.id)}
                    deleteIcon={<CancelCircle width={18} height={18} color="#C6CACC" />}
                    key={item.id}
                    style={{ backgroundColor: '#FFFFFF' }}
                    classes={{
                      label: classes.label,
                    }}
                  />
                </div>
              )
            }
          })()}
        </div>
      </div>
    );
  }

  renderSearchSection = (property, type) => {
    const { classes, childUsers, user } = this.props;
    const key = property.replaceAll('-', '_');
    const authorityType = type.replaceAll('-', '_');
    let selectAccount;
    let renderValue
    if (type === 'all' && property === 'executive-list') {
      const isEnabledExportExecutiveListFlag = isEnabledExportExecutiveList(user);
      const isEnabledSendLetterFlag = isEnabledSendLetter(user);

      // 権限がない、権限を削除した子アカウントをセレクトボックスに追加する
      selectAccount = childUsers && childUsers.filter(item =>
        (
          item.user_role[property]["edit-tag"] !== true ||
          (item.user_role[property]["download-list"] !== true && isEnabledExportExecutiveListFlag) ||
          (item.user_role[property]["order-letter"] !== true && isEnabledSendLetterFlag) ||
          (item.user_role[property]["download-letter-ordered-list"] !== true && isEnabledSendLetterFlag)
        ) ||
        (
          this.state.delAccounts[key].edit_tag.includes(item.id) ||
          (this.state.delAccounts[key].download_list.includes(item.id) && isEnabledExportExecutiveListFlag) ||
          (this.state.delAccounts[key].order_letter.includes(item.id) && isEnabledSendLetterFlag) ||
          (this.state.addAccounts[key].download_letter_ordered_list.includes(item.id) && isEnabledSendLetterFlag)
        )
      );
      // 権限を追加したらセレクトボックスから排除する
      selectAccount = selectAccount.filter(user =>
        (
          !this.state.addAccounts[key].edit_tag.includes(user.id) ||
          (!this.state.addAccounts[key].download_list.includes(user.id) && isEnabledExportExecutiveListFlag) ||
          (!this.state.addAccounts[key].order_letter.includes(user.id) && isEnabledSendLetterFlag) ||
          (!this.state.addAccounts[key].download_letter_ordered_list.includes(user.id) && isEnabledSendLetterFlag)
        )
      );
      // 選択中のアカウント
      renderValue = selectAccount.filter(user =>
        (
          this.state.addAccounts[key].edit_tag.includes(user.id) &&
          (this.state.addAccounts[key].download_list.includes(user.id) && isEnabledExportExecutiveListFlag) &&
          (this.state.addAccounts[key].order_letter.includes(user.id) && isEnabledSendLetterFlag) &&
          (this.state.addAccounts[key].download_letter_ordered_list.includes(user.id) && isEnabledSendLetterFlag)
        )
      );
      renderValue = renderValue.length > 0 ? renderValue : [-1];
      
    } else if (type === 'all' && property === 'house-list') {
      // 権限がない、権限を削除した子アカウントをセレクトボックスに追加する
      selectAccount = childUsers && childUsers.filter(item =>
        (item.user_role[property]["order-letter"] !== true ||
          item.user_role[property]["edit"] !== true ||
          item.user_role[property]["edit-tag"] !== true ||
          item.user_role[property]["download-list"] !== true) ||
        (this.state.delAccounts[key].order_letter.includes(item.id) ||
          this.state.delAccounts[key].edit.includes(item.id) ||
          this.state.delAccounts[key].edit_tag.includes(item.id) ||
          this.state.delAccounts[key].download_list.includes(item.id))
      );
      // 権限を追加したらセレクトボックスから排除する
      selectAccount = selectAccount.filter(user =>
      (!this.state.addAccounts[key].order_letter.includes(user.id) ||
        !this.state.addAccounts[key].edit.includes(user.id) ||
        !this.state.addAccounts[key].edit_tag.includes(user.id) ||
        !this.state.addAccounts[key].download_list.includes(user.id))
      );
      // 選択中のアカウント
      renderValue = selectAccount.filter(user =>
      (this.state.addAccounts[key].order_letter.includes(user.id) &&
        this.state.addAccounts[key].edit.includes(user.id) &&
        this.state.addAccounts[key].edit_tag.includes(user.id) &&
        this.state.addAccounts[key].download_list.includes(user.id))
      );
      renderValue = renderValue.length > 0 ? renderValue : [-1];
    } else {
      let addAccounts = this.state.addAccounts[key][authorityType] ? this.state.addAccounts[key][authorityType].toArray() : [];
      let delAccounts = this.state.delAccounts[key][authorityType] ? this.state.delAccounts[key][authorityType].toArray() : [];
      // 権限がない、権限を削除した子アカウントをセレクトボックスに追加する
      selectAccount = childUsers && childUsers.filter(item => !(item.user_role[property] && item.user_role[property][type] === true) || delAccounts.includes(item.id))
      // 権限を追加したらセレクトボックスから排除する
      selectAccount = selectAccount.filter(function (user) {
        return !addAccounts.includes(user.id);
      })
      renderValue = addAccounts && addAccounts.length > 0 ? addAccounts : [-1];
    }

    renderValue.push(-1);

    // 権限を追加できるアカウントがある場合セレクトボックスを表示する
    if (selectAccount && selectAccount.length) {
      return (
        <FormControl style={{ marginRight: "8px" }}>
          <Select
            value={renderValue}
            onChange={e => this.handleItemSelected(property, type, e.target.value)}
            classes={{
              select: classes.select,
            }}
            MenuProps={{
              getContentAnchorEl: null,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
              }
            }}
            multiple
          >
            <MenuItem key={-1} value={-1}>
              + 子アカウント名で検索
            </MenuItem>

            {selectAccount.map((account, i) => (
              <MenuItem key={i} value={account.id}>
                {account.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )
    }
  }

  renderDashBordAuthority() {
    const { classes } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.title} style={{ padding: '26px 25px' }}>
          <Typography variant="subheading" style={{ margin: 'auto 0', fontWeight: 'bold', fontSize: '16px' }}>
            ダッシュボード
          </Typography>
        </div>
        <div className={classes.content}>
          <div className={classes.menuContent}>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: '#195AFF', padding: 0 }}
            >
              閲覧
            </Button>
          </div>
          <div className={classes.readSection}>
            <div className={classes.notExist}>
              ダッシュボードには、各アカウントに与えられた権限内での情報が表示されます。
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderLetterOrderAuthority() {
    const { classes } = this.props;
    const property = 'letter-order';
    const readAccount = this.haveAuthorityChildAccount(property, "read");

    // let btnTxt = '編集';
    // if (this.state.updateAuthority === property) {
    //     btnTxt = '変更を保存';
    // }

    return (
      <div className={classes.container}>
        <div className={classes.title} style={{ padding: '26px 25px' }}>
          <Typography variant="subheading" style={{ margin: 'auto 0', fontWeight: 'bold', fontSize: '16px' }}>
            注文履歴
          </Typography>
          {/* 最低限、閲覧にしないとダッシュボードなど影響が出るため一旦編集機能OFF */}
          {/* <Button
                        disabled={this.props.isSaving}
                        color={this.state.updateAuthority === property ? "default" : "primary"}
                        className={classNames(classes.button, this.state.updateAuthority === property ? classes.saveButton : classes.editButton)}
                        onClick={() => this.state.updateAuthority === property ? this.handleSave(property) : this.handleClick('updateAuthority', property)}
                        >
                        {btnTxt}
                    </Button> */}
        </div>
        <div className={classes.content}>
          <div className={classes.menuContent}>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: '#195AFF', padding: 0 }}
            >
              閲覧
            </Button>
          </div>
          <div className={classes.readSection}>
            <div className={classes.userContent}>
              {readAccount && (
                readAccount.map((item, i) => this.renderRow(item, i, "read", property))
              )}
            </div>
            {readAccount.length === 0 && (
              <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
            )}
          </div>
          <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none', marginTop: 15 }}>
            {this.renderSearchSection(property, "read")}
          </div>
        </div>
        <div className={classes.searchContent} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none' }}>
        </div>
      </div>
    )
  }

  renderDownloadHistoryAuthority() {
    const { classes, user } = this.props;
    // 一度もエクスポート可能なプランを契約していない場合は、画面を使えないため設定項目を表示しない
    if (!hasEverBeenEnabledExportPlan(user)) {
      return null;
    }
    const property = 'download-history';
    const readAccount = this.haveAuthorityChildAccount(property, "read");

    let btnTxt = '編集';
    if (this.state.updateAuthority === property) {
      btnTxt = '変更を保存';
    }

    return (
      <div className={classes.container}>
        <div className={classes.title}>
          <Typography variant="subheading" style={{ margin: 'auto 0', fontWeight: 'bold', fontSize: '16px' }}>
            ダウンロード履歴
          </Typography>
          <Button
            disabled={this.props.isSaving}
            color={this.state.updateAuthority === property ? "default" : "primary"}
            className={classNames(classes.button, this.state.updateAuthority === property ? classes.saveButton : classes.editButton)}
            onClick={() => this.state.updateAuthority === property ? this.handleSave(property) : this.handleClick('updateAuthority', property)}
          >
            {btnTxt}
          </Button>
        </div>
        <div className={classes.content}>
          <div className={classes.menuContent}>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: '#195AFF', padding: 0 }}
            >
              閲覧
            </Button>
          </div>
          <div className={classes.readSection}>
            <div className={classes.userContent}>
              {readAccount && (
                readAccount.map((item, i) => this.renderRow(item, i, "read", property))
              )}
            </div>
            {readAccount.length === 0 && (
              <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
            )}
          </div>
          <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none', marginTop: 15 }}>
            {this.renderSearchSection(property, "read")}
          </div>
        </div>
      </div>
    )
  }

  renderExecutiveListAuthority = () => {
    const { classes, childUsers, user } = this.props;
    const property = 'executive-list';
    const readAccount = this.haveAuthorityChildAccount(property, "read");
    const isEnabledExportExecutiveListFlag = isEnabledExportExecutiveList(user);
    const isEnabledSendLetterFlag = isEnabledSendLetter(user);

    let allAccount;

    // 権限がある、権限を追加した子アカウントを一覧に表示する
    allAccount = childUsers && childUsers.filter(item =>
      (
        item.user_role[property]["edit-tag"] === true &&
        (item.user_role[property]["download-list"] === true && isEnabledExportExecutiveListFlag) &&
        (item.user_role[property]["order-letter"] === true && isEnabledSendLetterFlag)  &&
        (item.user_role[property]["download-letter-ordered-list"] === true && isEnabledSendLetterFlag)
      ) ||
      (
        this.state.addAccounts.executive_list.edit_tag.includes(item.id) &&
        (this.state.addAccounts.executive_list.download_list.includes(item.id) && isEnabledExportExecutiveListFlag) &&
        (this.state.addAccounts.executive_list.order_letter.includes(item.id) && isEnabledSendLetterFlag) &&
        (this.state.addAccounts.executive_list.download_letter_ordered_list.includes(item.id) && isEnabledSendLetterFlag)
      )
    )
    // 権限がない、権限を削除した子アカウントを一覧から排除する
    allAccount = allAccount.filter(user =>
      (
        !this.state.delAccounts.executive_list.edit_tag.includes(user.id) &&
        (!this.state.delAccounts.executive_list.download_list.includes(user.id) && isEnabledExportExecutiveListFlag) &&
        (!this.state.delAccounts.executive_list.order_letter.includes(user.id) && isEnabledSendLetterFlag) &&
        (!this.state.delAccounts.executive_list.download_letter_ordered_list.includes(user.id) && isEnabledSendLetterFlag)
      )
    )

    let authorityInfo = [
      { title: 'リストの追加 / 編集', key: 'edit-tag' },
    ];

    if (isEnabledExportExecutiveListFlag) {
      authorityInfo.push(
        { title: 'キーマンリストDL', key: 'download-list' }
      );
    }

    if (isEnabledSendLetterFlag) {
      authorityInfo.push(
        { title: 'レター送付', key: 'order-letter' },
        { title: '注文済みキーマンDL', key: 'download-letter-ordered-list' }
      );
    }

    let btnTxt = '編集';
    if (this.state.updateAuthority === property) {
      btnTxt = '変更を保存';
    }

    return (
      <div className={classes.container}>
        <div className={classes.title}>
          <Typography variant="subheading" style={{ margin: 'auto 0', fontWeight: 'bold', fontSize: '16px' }}>
            キーマンデータベース
          </Typography>
          <Button
            disabled={this.props.isSaving}
            color={this.state.updateAuthority === property ? "default" : "primary"}
            className={classNames(classes.button, this.state.updateAuthority === property ? classes.saveButton : classes.editButton)}
            onClick={() => this.state.updateAuthority === property ? this.handleSave(property) : this.handleClick('updateAuthority', property)}
          >
            {btnTxt}
          </Button>
        </div>
        <div className={classes.content}>
          <div className={classes.menuContent}>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: this.state.exeAuthority === 'read' ? '#195AFF' : '#181819', padding: '0 15px 0 0', borderRight: ' 1px solid #D8DBDF' }}
              onClick={() => this.handleClick('exeAuthority', 'read')}>
              閲覧
            </Button>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: this.state.exeAuthority === 'edit' ? '#195AFF' : '#181819', padding: '0 0 0 15px' }}
              onClick={() => this.handleClick('exeAuthority', 'edit')}>
              編集
            </Button>
          </div>

          <div className={classes.readSection} style={{ display: this.state.exeAuthority === 'read' ? 'block' : 'none' }}>
            <div className={classes.userContent}>
              {readAccount && (
                readAccount.map((item, i) => this.renderRow(item, i, "read", property))
              )}
            </div>
            {readAccount.length === 0 && (
              <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
            )}
            <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none', marginTop: 15 }}>
              {this.renderSearchSection(property, "read")}
            </div>
          </div>
          <div className={classes.editSection} style={{ display: this.state.exeAuthority === 'edit' ? 'block' : 'none' }}>
            <div className={classes.subSection}>
              <div className={classes.sectionHeader}>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 'bold' }}
                >
                  すべての権限（レター送付 ・ キーマンリストDL ・ リストの追加 / 編集 ・ 注文済みキーマンDL）
                </Typography>
              </div>
              <div className={classes.userContent} >
                {allAccount && (
                  allAccount.map((item, i) => this.renderRow(item, i, "all", property))
                )}
              </div>
              {allAccount.length === 0 && (
                <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
              )}
            </div>
            <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none' }}>
              {this.renderSearchSection(property, "all")}
            </div>
            <div style={{ display: this.state.exeInfoOpen ? 'block' : 'none' }}>
              {authorityInfo.map((info, i) => this.renderSection(info, i, property))}
            </div>
            {this.renderExpandBtn(property)}
          </div>
        </div>
      </div>
    )
  }

  renderHouseListAuthority = () => {
    const { classes, childUsers } = this.props;
    const property = 'house-list';
    const readAccount = this.haveAuthorityChildAccount(property, "read");
    // 権限がある、権限を追加した子アカウントを一覧に表示する
    let allAccount = childUsers && childUsers.filter(item =>
      (item.user_role[property]["order-letter"] === true &&
        item.user_role[property]["edit"] === true &&
        item.user_role[property]["edit-tag"] === true &&
        item.user_role[property]["download-list"] === true) ||
      (this.state.addAccounts.house_list.order_letter.includes(item.id) &&
        this.state.addAccounts.house_list.edit.includes(item.id) &&
        this.state.addAccounts.house_list.edit_tag.includes(item.id) &&
        this.state.addAccounts.house_list.download_list.includes(item.id))
    )
    // 権限がない、権限を削除した子アカウントを一覧から排除する
    allAccount = allAccount.filter(user =>
    (!this.state.delAccounts.house_list.order_letter.includes(user.id) &&
      !this.state.delAccounts.house_list.edit.includes(user.id) &&
      !this.state.delAccounts.house_list.edit_tag.includes(user.id) &&
      !this.state.delAccounts.house_list.download_list.includes(user.id)
    )
    )

    let btnTxt = '編集';
    if (this.state.updateAuthority === property) {
      btnTxt = '変更を保存';
    }

    const authorityInfo = [
      { title: 'レター送付', key: 'order-letter' },
      { title: 'アドレスの追加 / 編集', key: 'edit' },
      { title: 'リストの追加 / 編集', key: 'edit-tag' },
      { title: 'キーマンリストDL', key: 'download-list' },
    ]
    return (
      <div className={classes.container}>
        <div className={classes.title}>
          <Typography variant="subheading" style={{ margin: 'auto 0', fontWeight: 'bold', fontSize: '16px' }}>
            自社リスト
          </Typography>
          <Button
            disabled={this.props.isSaving}
            color={this.state.updateAuthority === property ? "default" : "primary"}
            className={classNames(classes.button, this.state.updateAuthority === property ? classes.saveButton : classes.editButton)}
            onClick={() => this.state.updateAuthority === property ? this.handleSave(property) : this.handleClick('updateAuthority', property)}
          >
            {btnTxt}
          </Button>
        </div>
        <div className={classes.content}>
          <div className={classes.menuContent}>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: this.state.houseListAuthority === 'read' ? '#195AFF' : '#181819', padding: '0 15px 0 0', borderRight: ' 1px solid #D8DBDF' }}
              onClick={() => this.handleClick('houseListAuthority', 'read')}>
              閲覧
            </Button>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: this.state.houseListAuthority === 'edit' ? '#195AFF' : '#181819', padding: '0 0 0 15px' }}
              onClick={() => this.handleClick('houseListAuthority', 'edit')}>
              編集
            </Button>
          </div>

          <div className={classes.readSection} style={{ display: this.state.houseListAuthority === 'read' ? 'block' : 'none' }}>
            <div className={classes.userContent}>
              {readAccount && (
                readAccount.map((item, i) => this.renderRow(item, i, "read", property))
              )}
            </div>
            {readAccount.length === 0 && (
              <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
            )}
            <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none', marginTop: 15 }}>
              {this.renderSearchSection(property, "read")}
            </div>
          </div>
          <div className={classes.editSection} style={{ display: this.state.houseListAuthority === 'edit' ? 'block' : 'none' }}>
            <div className={classes.subSection}>
              <div className={classes.sectionHeader}>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 'bold' }}
                >
                  すべての権限（レター送付 ・ リストの追加 / 編集 ・ 注文済みキーマンDL）
                </Typography>
              </div>
              <div className={classes.userContent} >
                {allAccount && (
                  allAccount.map((item, i) => this.renderRow(item, i, "all", property))
                )}
              </div>
              {allAccount.length === 0 && (
                <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
              )}
            </div>
            <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none' }}>
              {this.renderSearchSection(property, "all")}
            </div>
            <div style={{ display: this.state.houseListInfoOpen ? 'block' : 'none' }}>
              {authorityInfo.map((info, i) => this.renderSection(info, i, property))}
            </div>
            {this.renderExpandBtn(property)}
          </div>
        </div>
      </div>
    )
  }

  renderTimelineAuthority = () => {
    const { classes } = this.props;
    const property = 'timeline';
    const readAccount = this.haveAuthorityChildAccount(property, "read");
    const editAccount = this.haveAuthorityChildAccount(property, "edit");

    let btnTxt = '編集';
    if (this.state.updateAuthority === property) {
      btnTxt = '変更を保存';
    }

    return (
      <div className={classes.container}>
        <div className={classes.title}>
          <Typography variant="subheading" style={{ margin: 'auto 0', fontWeight: 'bold', fontSize: '16px' }}>
            タイムライン
          </Typography>
          <Button
            disabled={this.props.isSaving}
            color={this.state.updateAuthority === property ? "" : "primary"}
            className={classNames(classes.button, this.state.updateAuthority === property ? classes.saveButton : classes.editButton)}
            onClick={() => this.state.updateAuthority === property ? this.handleSave(property) : this.handleClick('updateAuthority', property)}
          >
            {btnTxt}
          </Button>
        </div>
        <div className={classes.content}>
          <div className={classes.menuContent}>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: this.state.timelineAuthority === 'read' ? '#195AFF' : '#181819', padding: '0 15px 0 0', borderRight: ' 1px solid #D8DBDF' }}
              onClick={() => this.handleClick('timelineAuthority', 'read')}>
              閲覧
            </Button>
            <Button
              color="default"
              className={classes.menuButton}
              style={{ color: this.state.timelineAuthority === 'edit' ? '#195AFF' : '#181819', padding: '0 0 0 15px' }}
              onClick={() => this.handleClick('timelineAuthority', 'edit')}>
              編集
            </Button>
          </div>

          <div className={classes.readSection} style={{ display: this.state.timelineAuthority === 'read' ? 'block' : 'none' }}>
            <div className={classes.userContent}>
              {readAccount && (
                readAccount.map((item,i) => this.renderRow(item, i, "read", property))
              )}
            </div>
            {readAccount.length === 0 && (
              <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
            )}
            {/*「アクセス不可」を一旦OFFのため閲覧は編集不可 */}
            {/* <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none' }}>
                        {this.renderSearchSection(property, "read")}
                    </div> */}
          </div>
          <div className={classes.editSection} style={{ display: this.state.timelineAuthority === 'edit' ? 'block' : 'none' }}>
            <div className={classes.subSection}>
              <div className={classes.sectionHeader}>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 'bold' }}
                >
                  ステータスの編集
                </Typography>
              </div>
              <div className={classes.userContent} >
                {editAccount && (
                  editAccount.map((item, i) => this.renderRow(item, i, "edit", property))
                )}
              </div>
              {editAccount.length === 0 && (
                <div className={classes.notExist}>権限を持っているアカウントはありません。</div>
              )}
            </div>
            <div className={classes.searchSection} style={{ display: this.state.updateAuthority === property ? 'flex' : 'none' }}>
              {this.renderSearchSection(property, "edit")}
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const { classes } = this.props;
    let notification, confirmCloseDialog, confirmPageTransitionDialog;
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }
    if (this.state.showConfirmCloseDialog) {
      confirmCloseDialog = this.renderConfirmCloseDialog();
    }
    if (this.state.showConfirmPageTransitionDialog) {
      confirmPageTransitionDialog = this.renderConfirmPageTransitionDialog();
    }

    if (this.props.isLoading) {
      return (
        <div className={classes.emptyContainer}>
          <Loader type="color" size="large" />
        </div>
      )
    } else {
      return (
        <Wrapper className={classes.root}>
          <Prompt
            when={Boolean(this.state.updateAuthority)}
            message={(location) => {
              this.toggleConfirmPageTransitionDialog(location.pathname);
              return false;
            }}
          />
          <div>
            {this.renderDashBordAuthority()}
            {this.renderLetterOrderAuthority()}
            {this.renderDownloadHistoryAuthority()}
            {this.renderExecutiveListAuthority()}
            {this.renderHouseListAuthority()}
            {this.renderTimelineAuthority()}
          </div>
          {notification}
          {confirmCloseDialog}
          {confirmPageTransitionDialog}
        </Wrapper>
      )
    }
  }
}

ChildAccountAuthoritySetting.propTypes = {
  classes: PropTypes.object.isRequired,
  putChildUsersAuthority: PropTypes.func,
  message: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  error: PropTypes.object,
  isSaving: PropTypes.bool,
  isLoading: PropTypes.bool,
  childUsers: PropTypes.array,
  user: PropTypes.object,
  goTo: PropTypes.func,
};

export default withStyles(styles)(ChildAccountAuthoritySetting);




// WEBPACK FOOTER //
// ./src/components/AccountSetting/ChildAccountAuthoritySetting.jsx